import { useState } from "react";
import { Copy, Check, Download, Terminal } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";

const BACKEND = process.env.REACT_APP_BACKEND_URL;

export function AgentSetupCard({ title = "Instala el agente en tu Mac (solo una vez)", reason }) {
  const [copied, setCopied] = useState(false);
  const origin = window.location.origin;
  const cmd = `curl -fsSL "${BACKEND}/api/agent-installer/install.sh" | bash -s -- "${BACKEND}" "${origin}"`;
  const zipUrl = `${BACKEND}/api/agent-installer/KRAI-Agent-Instalar.zip?base=${encodeURIComponent(BACKEND)}&origin=${encodeURIComponent(origin)}`;

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(cmd);
      setCopied(true);
      toast.success("Comando copiado");
      setTimeout(() => setCopied(false), 2000);
    } catch {
      toast.error("No se pudo copiar; selecciónalo manualmente");
    }
  };

  return (
    <div className="mt-4 rounded-sm border border-emerald-500/30 bg-emerald-500/5 p-4" data-testid="agent-setup-card">
      <div className="flex items-center gap-2 text-emerald-300">
        <Terminal className="h-4 w-4" />
        <span className="font-heading text-sm font-semibold">{title}</span>
      </div>
      {reason && <p className="mt-1 text-xs text-[#a3a3a3]" data-testid="agent-setup-reason">{reason}</p>}
      <ol className="mt-3 list-decimal space-y-1 pl-5 text-xs text-[#d4d4d4]">
        <li>Abre <b>Terminal</b> en tu Mac (⌘ + Espacio, escribe «Terminal»).</li>
        <li>Pega este comando y pulsa Enter. Se abrirá Finder: elige tu carpeta <b>KRAI-LOCAL-AI-APP</b> (la que contiene «agent»).</li>
        <li>Vuelve aquí y pulsa <b>Conectar</b>. Desde entonces el agente arranca solo al encender el Mac.</li>
      </ol>
      <div className="mt-3 flex flex-col gap-2 sm:flex-row">
        <code className="flex-1 overflow-x-auto whitespace-nowrap rounded-sm border border-[#262626] bg-[#0a0a0a] px-3 py-2 font-mono text-[11px] text-[#e5e5e5]" data-testid="agent-setup-command">
          {cmd}
        </code>
        <Button data-testid="agent-setup-copy" onClick={copy} className="shrink-0 rounded-sm bg-emerald-500 text-black hover:bg-emerald-400">
          {copied ? <Check className="mr-2 h-4 w-4" /> : <Copy className="mr-2 h-4 w-4" />}
          {copied ? "Copiado" : "Copiar comando"}
        </Button>
      </div>
      <a href={zipUrl} data-testid="agent-setup-download" className="mt-3 inline-flex items-center gap-1.5 font-mono text-[11px] text-[#a3a3a3] hover:text-white">
        <Download className="h-3.5 w-3.5" /> O descarga el instalador (.zip): descomprímelo y haz clic derecho → Abrir en «Instalar KRAI Agent.command»
      </a>
    </div>
  );
}
